{
  "messages": {
    "processing": "Procesando archivo...",
    "dragHere": "Arrastra tu SVG aquí."
  }
}
